import QualifiedProspects from './QualifiedProspects'
import CheckIcons from '@/icons/CheckIcons'
import StopCircleIcons from '@/icons/StopCircleIcons'
import CoolleadIcons from '@/icons/CoolleadIcons'
import WatchIcons from '@/icons/WatchIcons'
import CoolLead from './CoolLead'
import DeadLead from './DeadLead'
import Deleted from './Deleted'
import Active from './Active'
import PeopleIcons from '@/icons/PeopleIcons'
import CustomerTrial from './Trial'
import CustomerCancelled from './Cancelled'
import type { TFunction } from 'i18next'
import { Skull, Trash2 } from 'lucide-react'
import { formatNumeral } from '@/utils/function'

interface CustomerCounts {
    qualified_prospects: number
    cool_leads: number
    dead_leads: number
    active: number
    trial: number
    cancelled: number
    deleted?: number
}

interface TabsOptions {
    counts?: CustomerCounts
    t: TFunction
    isAdmin: boolean
}

export const tabs = ({ counts, t, isAdmin }: TabsOptions) => {
    const baseTabs = [
        {
            label: t('customers.qualified-prospects', {
                count: formatNumeral(counts?.qualified_prospects || 0, 0),
            } as any),
            value: 'qualified-prospects',
            startIcon: <PeopleIcons />,
            component: <QualifiedProspects />,
        },
        {
            label: t('customers.coollead', {
                count: (formatNumeral(counts?.cool_leads || 0, 0) as any) || 0,
            }),
            value: 'coollead',
            startIcon: <CoolleadIcons />,
            component: <CoolLead />,
        },
        {
            label: t('customers.active', {
                count: (formatNumeral(counts?.active || 0, 0) as any) || 0,
            }),
            value: 'active',
            startIcon: <CheckIcons />,
            component: <Active />,
        },
        {
            label: t('customers.trial', {
                count: (formatNumeral(counts?.trial || 0, 0) as any) || 0,
            }),
            value: 'trial',
            startIcon: <WatchIcons />,
            component: <CustomerTrial />,
        },
        {
            label: t('customers.stop', {
                count: (formatNumeral(counts?.cancelled || 0, 0) as any) || 0,
            }),
            value: 'stop',
            startIcon: <StopCircleIcons />,
            component: <CustomerCancelled />,
        },
        {
            label: t('customers.deadlead', {
                count: (formatNumeral(counts?.dead_leads || 0, 0) as any) || 0,
            }),
            value: 'deadlead',
            startIcon: <Skull className="w-4 h-4" />,
            component: <DeadLead />,
        },
    ]

    // Admin-only tab for deleted customers
    if (isAdmin) {
        baseTabs.push({
            label: t('customers.deleted', {
                count: (formatNumeral(counts?.deleted || 0, 0) as any) || 0,
            }),
            value: 'deleted',
            startIcon: <Trash2 className="w-4 h-4" />,
            component: <Deleted />,
        })
    }

    return baseTabs
}
